import * as React from "react";
import { facepaintMediaQueries } from "../shared";
import { grid } from "../../tokens";
import { jsx as ___EmotionJSX } from "@emotion/core";
var pageStyles = function pageStyles(maxWidth) {
  return facepaintMediaQueries({
    boxSizing: "content-box",
    margin: "0 auto",
    maxWidth: maxWidth,
    padding: [0, "0 ".concat(grid.small, "px"), "0 ".concat(grid.medium, "px"), "0 ".concat(grid.large, "px")]
  });
};
export var NarrowPage = function NarrowPage(_ref) {
  var children = _ref.children,
    className = _ref.className;
  return ___EmotionJSX("div", {
    "data-bpl": true,
    css: pageStyles(840),
    className: className
  }, children);
};
export var MediumPage = function MediumPage(_ref2) {
  var children = _ref2.children,
    className = _ref2.className;
  return ___EmotionJSX("div", {
    "data-bpl": true,
    css: pageStyles(1136),
    className: className
  }, children);
};
export var WidePage = function WidePage(_ref3) {
  var children = _ref3.children,
    className = _ref3.className;
  return ___EmotionJSX("div", {
    "data-bpl": true,
    css: pageStyles(1440),
    className: className
  }, children);
};